import { useRef } from 'react';
import ConfigUtil from '../util/ConfigUtil';
import EnrolmentCautionModal from '../view/modal/EnrolmentCautionModal';
import ModalRef from './ModalRef';
import UniversitySemesterModal from '../view/modal/UniversitySemesterModal';
import EnrolmentUnivCautionModal from '../view/modal/EnrolmentUnivCautionModal';

const CautionBox = ({ userId, title, isEnrolment = false, semesterId, semesterNm }) => {
    const modalRef = useRef(null);

    const onClick = () => {
        modalRef.current.open(
            // <EnrolmentCautionModal userId={userId} modalRef={modalRef} isEnrolment={isEnrolment} />,
            <EnrolmentUnivCautionModal userId={userId} modalRef={modalRef} isEnrolment={isEnrolment} />,
            'large',
        );
    };

    const onClickUniversitySemesterList = () => {
        modalRef.current.open(
            <UniversitySemesterModal semesterId={semesterId} semesterNm={semesterNm} modalRef={modalRef} />,
            'medium',
        );
    };
    return (
        <>
            <div style={{ display: 'flex' }}>
                <div className='lec-check-info-button' style={{ marginRight: '20px' }}>
                    <button style={{ border: 0, outline: 0, cursor: 'pointer' }} onClick={onClick}>
                        {title}
                    </button>
                </div>
                <div className='lec-check-info-button' style={{ marginRight: '20px' }}>
                    <button
                        style={{ border: 0, outline: 0, cursor: 'pointer' }}
                        onClick={onClickUniversitySemesterList}
                    >
                        대학별 수강신청 기간
                    </button>
                </div>
                <a
                    href={ConfigUtil.getExternalLink_Curriculum()}
                    rel='noopener noreferrer'
                    target='_blank'
                    className='post-file-comment'
                    style={{ marginTop: '13px' }}
                >
                    교육과정/교과목 구성 안내
                </a>
            </div>

            <ModalRef ref={modalRef} />
        </>
    );
};

export default CautionBox;
